'use strict';
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
Object.defineProperty(exports, Symbol.toStringTag, {
    value: 'Module'
});
function partialRight(func) {
    for(var _len = arguments.length, partialArgs = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        partialArgs[_key - 1] = arguments[_key];
    }
    return partialRightImpl.apply(void 0, [
        func,
        placeholderSymbol
    ].concat(_to_consumable_array(partialArgs)));
}
function partialRightImpl(func, placeholder) {
    for(var _len = arguments.length, partialArgs = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++){
        partialArgs[_key - 2] = arguments[_key];
    }
    var partialedRight = function partialedRight() {
        for(var _len = arguments.length, providedArgs = new Array(_len), _key = 0; _key < _len; _key++){
            providedArgs[_key] = arguments[_key];
        }
        var placeholderLength = partialArgs.filter(function(arg) {
            return arg === placeholder;
        }).length;
        var rangeLength = Math.max(providedArgs.length - placeholderLength, 0);
        var remainingArgs = providedArgs.slice(0, rangeLength);
        var providedArgsIndex = rangeLength;
        var substitutedArgs = partialArgs.slice().map(function(arg) {
            return arg === placeholder ? providedArgs[providedArgsIndex++] : arg;
        });
        return func.apply(this, remainingArgs.concat(substitutedArgs));
    };
    if (func.prototype) {
        partialedRight.prototype = Object.create(func.prototype);
    }
    return partialedRight;
}
var placeholderSymbol = Symbol('partialRight.placeholder');
partialRight.placeholder = placeholderSymbol;
exports.partialRight = partialRight;
exports.partialRightImpl = partialRightImpl;
